import React, { Fragment, useState, } from "react";
import { useSiteDropdown, useLocationDropdown } from 'hooks/configuration/zone/zone';
import { useAddGateway, useEditGateway } from "hooks/configuration/rfid/rfid"
import { Button, Row, Col, Form, Input, Select, message } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Image from 'helpers/Image';
import "../style.css";
import { useEffect } from "react";

const { Option } = Select;

const FormGateWay = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const editData = useLocation();
    const [serverErrors, setServerErrors] = useState({});
    const create = editData.pathname === "/configuration/rfid/create";
    const [selectedSiteId, setSelectedSiteId] = useState(null);
    const [, setUpdateData] = useState(null);
    const [, setSiteID] = useState(null);
    const { data: siteDropdownData } = useSiteDropdown();
    const { data: locationDropdown } = useLocationDropdown(selectedSiteId || 0);
    // const { data: floorDropdownData, refetch: floorRefetch } = useFloorDropdown(siteid);
    // const { data: zoneEditDropdownData, refetch } = useZoneEditDropdown(updateData);

    const { mutate: addGateway, isLoading: Loading } = useAddGateway();
    const { mutate: editGateway, isLoading: editLoading } = useEditGateway();

    const onFinish = (formDatas) => {
        if (create) {
            const submitData = { ...formDatas };
            submitData.readerName = formDatas.readerName.trim();
            submitData.antennaNumber = formDatas.antennaNumber || 0;
            // submitData.gatewayId = formDatas.gatewayId;
            submitData.antennaType = formDatas.antennaType;
            submitData.siteId = formDatas.siteId || 0;
            // submitData.floorId = formDatas.floorId || 0;
            submitData.locationId = formDatas.locationId || 0;
            submitData.active = true;
            let formData = JSON.stringify(submitData)
            addGateway(formData, {
                onSuccess: (item) => {
                    if (item?.statusCode === 200) {
                        message?.success(item?.message);
                        navigate("/configuration/rfid");
                    } else {
                        message?.error(item?.message);
                    }
                },
                onError: (error) => {
                    if (error?.response?.data?.errorMessages) {
                        const errorMessages = error.response.data.errorMessages;
                        setServerErrors(errorMessages);
                    } 
                }
            })
        } else {
            const submitData = { ...formDatas };

            // submitData.gatewaySerialNumber = formDatas.gatewaySerialNumber;
            submitData.rfidId = formDatas.rfidId || 0;
            submitData.readerName = formDatas.readerName.trim();
            submitData.antennaNumber = formDatas.antennaNumber || 0;
            submitData.antennaType = formDatas.antennaType;
            submitData.siteId = formDatas.siteId || 0;
            // submitData.floorId = formDatas.floorId || 0;
            submitData.locationId = formDatas.locationId || 0;
            submitData.active = formDatas.active;
            let formData = JSON.stringify(submitData)
            editGateway(formData, {
                onSuccess: (item) => {
                    if (item?.statusCode === 200) {
                        message.success(item?.message);
                        navigate("/configuration/rfid");
                    } else {
                        message.error(item?.message);
                    }
                },
                onError: (error) => {
                    if (error?.response?.data?.errorMessages) {
                        const errorMessages = error.response.data.errorMessages;
                        setServerErrors(errorMessages);
                    } 
                }
            })
        }
    }

    const clearError = (name) => {
        setServerErrors(prev => ({ ...prev, [name]: "" }));
    };

    const status = [
        { 'label': "Active", "value": true },
        { 'label': "InActive", "value": false },
    ]

    const onHandleChange = (value) => {
        setSiteID(value);
        form.setFieldsValue({ "floorId": null })
        form.setFieldsValue({ "zoneId": null })
        setSelectedSiteId(value); // Update siteId state
        form.setFieldsValue({ locationId: undefined });
    };

    // useEffect(() => {
    //     if (updateData !== null) {
    //         refetch();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [updateData])

    // useEffect(() => {
    //     if (siteid !== null) {
    //         floorRefetch();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [siteid])

    useEffect(() => {
        if (editData) {
            setSelectedSiteId(editData?.state?.siteId)
            form.setFieldsValue({
                // "gatewaySerialNumber": editData?.state?.gatewaySerialNumber,
                "readerName": editData?.state?.readerName,
                "rfidId": editData?.state?.rfidId,
                "antennaNumber": editData?.state?.antennaNumber,
                "antennaType": editData?.state?.antennaType,
                "siteId": editData?.state?.siteId !== 0 ? editData?.state?.siteId : null,
                "floorId": editData?.state?.floorId !== 0 ? editData?.state?.floorId : null,
                "locationId": editData?.state?.locationId !== 0 ? editData?.state?.locationId : null,
                "active": editData?.state?.active,
            });
        }
        if (create === false) {
            setSiteID(editData?.state?.siteId)
            setUpdateData(editData?.state?.floorId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData])

    return (
        <Fragment>
            <div className="form-page">
                <div className="form-head form-head-sticky">
                    <div className="form-head-left">
                        <Link to="/configuration/rfid" className="form-back">
                            <Image name="backArrow.svg" />
                        </Link>
                        <div className="form-title">
                            <h1>{create ? "New RFID Reader" : `Edit ${editData?.state?.readerName}`}</h1>
                            <p>{create ? "Register an RFID reader and where it is installed" : "Update this reader and where it is installed"}</p>
                        </div>
                    </div>
                    <div className="form-actions">
                        <Button className="form-cancel" onClick={() => navigate("/configuration/rfid")}>Cancel</Button>
                        <Button className="form-submit" loading={Loading || editLoading} onClick={() => form.submit()} htmlType="submit">
                            <Image className="save-img" name="save.svg" /> {create ? "Save" : "Update"}
                        </Button>
                    </div>
                </div>

                <div className="form-card">
                    <Form
                        form={form}
                        colon={false}
                        onFinish={onFinish}
                        layout="vertical">
                        <Form.Item name="rfidId" hidden={true}>
                            <Input />
                        </Form.Item>

                        <section className="form-section">
                            <div className="form-section-head">
                                <h2>Reader details</h2>
                                <p>How this reader identifies itself and which antenna it uses.</p>
                            </div>
                            <Row gutter={[24, 0]}>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Reader Name" name="readerName" rules={[{ required: true, message: "Enter the rfid name!", whitespace: true }]} validateStatus={serverErrors?.rfid ? "error" : ""}
                                        help={serverErrors?.rfid?.[0]}>
                                        <Input placeholder="Enter the rfid name" maxLength={40} onChange={() => clearError("rfid")} ></Input>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Antenna Number" name="antennaNumber" rules={[{ required: true, message: "Enter the Antenna Number!" }]} validateStatus={serverErrors?.antennaNumber ? "error" : ""}
                                        help={serverErrors?.antennaNumber?.[0]}>
                                        <Input placeholder="Enter the Antenna Number" onChange={() => clearError("antennaNumber")}></Input>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Antenna Type" name="antennaType" rules={[{ required: true, message: "Antenna Type is required!" }]}>
                                        <Select placeholder={"Select Antenna Type"}>
                                            {["In", "Out"].map((item, a) => (
                                                <Option value={item} key={a}>{item}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                {create ? null : (
                                    <Col xs={24} sm={12} lg={6}>
                                        <Form.Item label="Status" name="active" rules={[{ required: true, message: "Status is required!" }]}>
                                            <Select placeholder={"Select Status"} options={status} />
                                        </Form.Item>
                                    </Col>
                                )}
                            </Row>
                        </section>

                        <section className="form-section">
                            <div className="form-section-head">
                                <h2>Placement</h2>
                                <p>Where this reader is installed on site.</p>
                            </div>
                            <Row gutter={[24, 0]}>
                                <Col xs={24} md={12}>
                                    <Form.Item label="Site" name="siteId" rules={[{ required: false, message: "Site is required!" }]}>
                                        <Select
                                            onChange={onHandleChange}
                                            placeholder={"Select Site"}
                                        >
                                            {siteDropdownData?.data.map((item, a) => (
                                                <Option value={item.siteId} key={a}>{item?.siteName}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label="Location" name="locationId" >
                                        <Select
                                            placeholder={"Select Location"}
                                        >
                                            {locationDropdown?.data?.map((item, a) => (
                                                <Option value={item.locationId} key={a}>{item?.locationName}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </section>
                    </Form>
                </div>
            </div>
        </Fragment>
    )
}
export default FormGateWay;